const RATES_ATTRIBUTES = {
  BESTVALUE: 'BESTVALUE',
  CHEAPEST: 'CHEAPEST',
  FASTEST: 'FASTEST',
};

export { RATES_ATTRIBUTES };
